// This icon file is generated automatically.
var PCaretRightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M10.18 5.71L4.23.58C4.01.38 3.7.56 3.7.87v10.26c0 .3.32.48.54.29l5.95-5.13a.4.4 0 000-.58z", "fill-rule": "nonzero" } }] }, "name": "p-caret-right", "theme": "outlined" };
export default PCaretRightOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PCaretRightOutlined.js
// module id = 3268
// module chunks = 0